import request from '@/service/request'

/* 桌球室排期规则，分页
* @params
* */
export const pageSnookerRuleApi = (params) => {
  return request.post('/stu/snookerRule/page', params)
}

/* 桌球室排期规则，list
* @params
* */
export const listSnookerRuleApi = (params = {}) => {
  return request.post('/stu/snookerRule/list', params)
}

/* 桌球室排期规则，根据id获取
* @params
* */
export const getSnookerRuleByIdApi = (id) => {
  return request.post(`/stu/snookerRule/get/${id}`)
}

/* 桌球室排期规则，根据校区id获取
* @params {string} campusId 校区id
* */
export const getSnookerRuleByCampusIdApi = (campusId) => {
  return request.post(`/stu/snookerRule/getByCampusId/${campusId}`)
}
/* 桌球室排期规则，删除
* @params
* */
export const delSnookerRuleByIdApi = (id) => {
  return request.post(`/stu/snookerRule/del/${id}`)
}

/* 桌球室排期规则，保存
* @params
* */
export const saveSnookerRuleApi = (params) => {
  return request.post('/stu/snookerRule/save', params)
}
